type CheckInErrorsType = {
  alreadyCheckedInToday: string
  checkInLimitReached: string
}

export const checkInErrors: CheckInErrorsType = {
  alreadyCheckedInToday: "You're checked in.",
  checkInLimitReached:
    "You've Reached Your Daily Check-In Limit. We'll see you again tomorrow!",
}
